export enum PaymentsConditionsEnum {
  EmailConfirmed = 'email_confirmed',
  KycVerified = 'kyc_verified',
  MinBalanceAvailable = 'min_balance_available',
  ProfitForPeriodReceived = 'profit_for_period_received',
}
